// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The Parameter monitoringType
 */
export type MonitoringType = 'Periodic' | 'PeriodicInstantaneous' | 'PeriodicComposite' | 'Continuous';

export const MonitoringType = {
    Periodic: 'Periodic' as MonitoringType,
    PeriodicInstantaneous: 'PeriodicInstantaneous' as MonitoringType,
    PeriodicComposite: 'PeriodicComposite' as MonitoringType,
    Continuous: 'Continuous' as MonitoringType
};

